import api from "@/services/api.service";

export default {
 name: 'request-contact',
 components: {},
 props: {
  caption: {
    type: String,
    default: "Request Contact List"
  },
  hover: {
    type: Boolean,
    default: true
  },
  striped: {
    type: Boolean,
    default: true
  },
  bordered: {
    type: Boolean,
    default: false
  },
  small: {
    type: Boolean,
    default: false
  },
  fixed: {
    type: Boolean,
    default: false
  }
},
data() {
  return {
    items: [],
    fields: [
    { key: "#" },
    { key: "actions", stickyColumn: true } ],
    sech: {},
    currentPage: 1,
    perPage: 10,
    totalRows: null,
    totalMarketingRequest: null,
    isBusy: true,
    delete_ids: [],
    allSelected: false,
    isApproved : true,
    permission_listRequestContactAgent: false,           
    permission_approveRequestContactAgent: false,   
    permission_deleteRequestContactAgent: false,
    superAdmin: false
  };
},
computed: {},
mounted() {},
async created() {
  let response = await api.post("users/user-permissions");
        const permissions = [];
        response.data[0].permission.forEach( function(element) {                
          permissions.push(element.action)
        }.bind(this));
        if(permissions.includes("list_conatct_assigned_agent_event")==true||permissions.includes("approve_conatct_assigned_agent_event")==true){
          this.getMarketingRequestContacts();
          this.permission_listRequestContactAgent = permissions.includes("list_conatct_assigned_agent_event");
          this.permission_approveRequestContactAgent = permissions.includes("approve_conatct_assigned_agent_event");
          this.permission_deleteRequestContactAgent = permissions.includes("delete_conatct_assigned_agent_event");
        }else if(response.data[0].role == 'super_admin'){
          this.getMarketingRequestContacts();
          this.superAdmin = true;
        }else if(permissions.includes("list_event") == true || permissions.includes("add_event") == true){
          this.makeToast("Permission denied","Alert","warning",6000);
          this.$router.push({name: 'Agent List'});
        }else{
          this.makeToast("Permission denied","Alert","warning",6000);
          this.$router.push({name: 'Admin Dashboard'});
        }
},
watch: {
  currentPage: {
    handler: function(page) {         
        this.getMarketingRequestContacts(page)
    }
  }
},
methods: {
  makeToast(message = "", title = "Alert", variant = "warning") {
    this.toastCount++;
    this.$root.$bvToast.toast(message, {
      title: title,
      variant: variant,
      autoHideDelay: 3000
    });
  },
  selectAll: function(e) {
    this.delete_ids = [];            
    if(e.target.checked){
      for (var item in this.items) {
        this.delete_ids.push(this.items[item].id.toString());
      }                
    }            
  },
  selectOne(){
    this.allSelected = false;            
  },
  async toSort (page = 1)
  {   
    this.items = [];
    this.sech.page = page;
    this.sech.marketing_event_id = this.$route.params.id;
    this.sech.request_id = this.$route.params.request_id;
    this.isBusy=true;
    this.sech.paginateVal = this.perPage;

    let response = await api.post("marketing-event/get-marketing-request-contacts", this.sech);          
    if (!response)
      this.makeToast("Something went to wrong please try again","Alert","danger",6000);
    if (response.status == "success") {
      if (response.data.data != "") {  
        //GET ALL HEADERS FROM JSON
        this.isApproved = (response.data.data[0].event_request.status == 'Done' ? true : false );
        var columns = Object.keys(Object.assign({}, ...[JSON.parse(response.data.data[0].exported_data)]));
        columns.splice(0,1);
        columns.map((h) => {
         this.fields.push({key: h, sortable: true}) 
        });

        //Iterate Data 
        response.data.data.forEach( function(element) {                    
          this.items.push(JSON.parse(element.exported_data));  
        }.bind(this));

        this.totalMarketingRequest = response.data.total;
        this.currentPage = response.data.current_page;
        this.perPage = response.data.per_page;        
      } else {
        this.items = [];
      }
    }      
    this.isBusy = false;
  },
  async getMarketingRequestContacts(page) {
    this.items = [];
    this.sech.page = page;
    this.sech.marketing_event_id = this.$route.params.id;
    this.sech.request_id = this.$route.params.request_id;
    this.isBusy=true;
    this.sech.paginateVal = this.perPage;

    let response = await api.post("marketing-event/get-marketing-request-contacts", this.sech);          
    if (!response)
      this.makeToast("Something went to wrong please try again","Alert","danger",6000);
    if (response.status == "success") {
      if (response.data.data != "") {  
        //GET ALL HEADERS FROM JSON
        this.isApproved = (response.data.data[0].event_request.status == 'Done' ? true : false );
        var columns = Object.keys(Object.assign({}, ...[JSON.parse(response.data.data[0].exported_data)]));

        columns.splice(0,1);
        columns.map((h) => {
         this.fields.push({key: h, sortable: true}) 
        });

        //Iterate Data 
        response.data.data.forEach( function(element) {                    
          //var id = [{id:element.id}];
          this.items.push(JSON.parse(element.exported_data));  
        }.bind(this));

        //this.fields.push({ key: "actions" });

        this.totalMarketingRequest = response.data.total;
        this.currentPage = response.data.current_page;
        this.perPage = response.data.per_page;
        this.pageOptions.forEach(element => {
          if(element.value > this.totalMarketingRequest){
              var indexOf = this.pageOptions.indexOf(element);
              if( indexOf != 0 )
              this.pageOptions.splice(indexOf)
          }
        });
        if(this.totalMarketingRequest <= 500)
        this.pageOptions.push({text:'All',value:this.totalMarketingRequest});
      } else {
        this.items = [];
      }
    }      
    this.isBusy = false;
  },
  getRowCount(items) {
    return items.length;
  },
  multipleDelete(){
    this.$bvModal
    .msgBoxConfirm("Are you sure want to delete this Marketing Event Request Contacts?")
    .then(value => {
      if (value) {
        this.deleteMarketingContact(this.delete_ids, 0);
      } else {
        return;
      }
    })
    .catch(function() {
      return;
    });
  },singleDelete(id, index) {
    this.$bvModal
    .msgBoxConfirm("Are you sure want to delete this Marketing Event Request Contact?")
    .then(value => {
      if (value) {
        this.deleteMarketingContact(id, index);
      } else {
        return;
      }
    })
    .catch(function() {
      return;
    });
  },
  async deleteMarketingContact(id, index) {

    let response = await api.post("admin/marketing-event/delete-request-contact",
      { id: id , marketing_event_id : this.$route.params.id });

    if (!response)
      this.makeToast("Something went to wrong please try again","Alert","danger",6000);

    if (response.status == "success") {

      if(index == 0){
        this.items = [];
        this.getMarketingRequestContacts();
      }
      else
        this.items.splice(index, 1);

      this.makeToast(response.message || `Marketing Event delete successful.`,"Alert","success");
    } 
    else 
      this.makeToast(`Marketing Event not deleted.`, "Alert", "danger");
  },
 async approveRequestedContacts(){

    let response = await api.post("admin/marketing-event/approve-requested-contacts",
      {marketing_event_id : this.$route.params.id , request_id : this.$route.params.request_id });

    if (!response)
      this.makeToast("Something went to wrong please try again","Alert","danger",6000);

    if (response.status == "success") {
      this.isApproved = true;
      this.makeToast(response.message || `Marketing Event approved successful.`,"Alert","success");
    } 
    else{
      for (var error in response.errors)
                        this.makeToast(response.errors[error], 'Alert', 'danger', 6000)
    } 
  }
}
};
